import React from "react";
import { connect } from "react-redux";
import { Col } from "react-bootstrap";
import PropTypes from "prop-types";

import Table from "../../../layout/table";
import { list as getCodes} from "../../../actions/expense.codes";
import { only as numbersOnly, currency as formatCurrency  } from "../../../utils/number";
import { phone } from "../../../utils/string";

import ConditionalButton from "../../../layout/conditional-button";
import { send as pageInfo, loading } from "../../../actions/page";
import { withNavigation } from "../../../utils/wrapper";
import CsLineIcons from "../../../cs-line-icons";

class ExpenseCodes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
        this.props.loading(true);
    }

    componentDidMount = () => {
        setTimeout(async () => {
            await this.loadData();
        }, 30);
    }


    loadData = async () => {
        this.props.loading(true);

        const __data = await this.props.getCodes();

        this.setState({
            data: __data
        });

        await this.props.pageInfo({ title: "Expense Codes", breadcrumb: `Expense Codes` });
        this.props.loading(false);

    }


    get headers() {        
        return [
            {
                header: "Code",
                sortable: true,
                source: "code",
                className: "text-muted text-small text-uppercase w-30",
                onFormat: this.onLinkFormat
            },
            {
                header: "Caption",
                sortable: true,
                source: "caption",
                className: "text-muted text-small text-uppercase w-30",
                onFormat: this.onLinkFormat
            },
            {
                header: "Amount",
                sortable: true,
                source: "each",
                className: "text-muted text-small text-uppercase w-40",
                onFormat: this.onValueFormat
            }
        ]
    }



    onValueFormat = (e, row) => {
        return formatCurrency(Number(e));
    }


    onLinkFormat = (e, row) => {
        return `<a href="/dashboard/settings/expenses/${row['uuid']}">${e}</a>`
    }

    onNewClick = (e) => {
        this.props.navigate("add");
    }

    render() {
        return (
            <>
                <Col md="8" className="float-right text-end">
                    <ConditionalButton enabledVariant="outline-primary" tooltip="Create new expense" display enabled={true} onEnabledClick={this.onNewClick} icon="flash">New</ConditionalButton>
                </Col>
                <Col xs="12">
                    <Table
                        headers={this.headers}
                        page={this.state.data}
                        size={this.state.size}
                        index={this.state.page}
                        pages={this.state.pages}
                        onColumnClick={this.onColumnClick}
                        onPageChange={this.onPageChange}
                        onSearch={this.onSearch}
                        onSize={this.onSize}
                        searchable={false}
                        sizable={false}
                    />
                </Col>
            </>
        )
    }
}

ExpenseCodes.propTypes = {
    auth: PropTypes.object.isRequired
};

const mapStateToProps = (state) => {
    return ({
        auth: state.auth
    });
};

export default withNavigation(connect(mapStateToProps, { getCodes, loading, pageInfo })(ExpenseCodes));
